import { useCallback, useState } from 'react';
import { requestWhatsappHandoff } from '../api/botApi';

/**
 * Drives the "Continue on WhatsApp" button.
 *
 * Asks the BE for a tokenized wa.me URL, then navigates the current tab so the
 * native WhatsApp install (mobile) or WhatsApp Web (desktop) handles the
 * prefilled message. The session.handed_off event on the socket will close
 * the panel once the BSP forwards the user's send back to us — ConnectOp,
 * the only live vendor since the SmartSend partnership ended in 2026-08.
 */
export function useWhatsappHandoff() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handoff = useCallback(async (sessionId: string) => {
    setBusy(true);
    setError(null);
    try {
      const { wa_url } = await requestWhatsappHandoff(sessionId);
      // Same-tab only. window.open(..., 'noopener') returns null even when a
      // tab was opened, so pairing it with a location.href fallback double-fires.
      window.location.href = wa_url;
    } catch (e: any) {
      const msg = e?.response?.data?.message ?? e?.message ?? 'handoff_failed';
      setError(msg);
    } finally {
      setBusy(false);
    }
  }, []);

  return { handoff, busy, error };
}
